import React from 'react';
import { Form, Input, Button, Space, Tag } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';

interface SellingPointsListProps {
    sellingPoints: string[];
    onUpdate: (index: number, value: string) => void;
    onAdd: () => void;
    onRemove: (index: number) => void;
}

export const SellingPointsList: React.FC<SellingPointsListProps> = ({
    sellingPoints,
    onUpdate,
    onAdd,
    onRemove,
}) => {
    return (
        <Form.Item
            label={
                <Space>
                    核心卖点
                    <Tag color="blue">{sellingPoints.filter(p => p.trim()).length} 条</Tag>
                </Space>
            }
            required
            tooltip="每条卖点将单独生成一条Bullet Point"
        >
            <div className="selling-points-list">
                {sellingPoints.map((point, index) => (
                    <div key={index} style={{ marginBottom: 8 }}>
                        <Input.Group compact>
                            <Input
                                style={{ width: 'calc(100% - 40px)' }}
                                value={point}
                                onChange={e => onUpdate(index, e.target.value)}
                                placeholder={`卖点 ${index + 1}：例如 "超长续航30小时"`}
                                prefix={<Tag color="orange">{index + 1}</Tag>}
                            />
                            <Button
                                type="text"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => onRemove(index)}
                                disabled={sellingPoints.length <= 1}
                            />
                        </Input.Group>
                    </div>
                ))}
                <Button
                    type="dashed"
                    onClick={onAdd}
                    icon={<PlusOutlined />}
                    style={{ width: '100%' }}
                >
                    添加卖点
                </Button>
            </div>
        </Form.Item>
    );
};
